// extracted by mini-css-extract-plugin
export default {"background":"OzX2fqdJjuXWk5TM5fTB","container":"fy0YAavfMskv0JkygduS"};